// Shared product data — imported by both Shop.js and ProductPage.js

export const personalProducts = [
  {
    id: "dot-series-5",
    name: "Dot Series 5",
    year: "2026",
    medium: "Acrylic on canvas",
    image:
      "/images/portfolio/paintings/paintings%20feature%20section/dot%20series/ds_5/ds_5_bot.jpeg",
    galleryImages: [
      "/images/portfolio/paintings/paintings%20feature%20section/dot%20series/ds_5/ds_5_front.jpeg",
      "/images/portfolio/paintings/paintings%20feature%20section/dot%20series/ds_5/ds_5_side.jpeg",
      "/images/portfolio/paintings/paintings%20feature%20section/dot%20series/ds_5/ds_5_bot.jpeg",
    ],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "dot-series-4",
    name: "Dot Series 4",
    year: "2021",
    medium: "Acrylic on canvas",
    image:
      "/images/portfolio/paintings/paintings%20feature%20section/dot%20series/ds_4/ds_4_stacked.jpeg",
    galleryImages: [
      "/images/portfolio/paintings/paintings%20feature%20section/dot%20series/ds_4/ds_4_front.jpeg",
      "/images/portfolio/paintings/paintings%20feature%20section/dot%20series/ds_4/ds_4_side.jpeg",
      "/images/portfolio/paintings/paintings%20feature%20section/dot%20series/ds_4/ds_4_stacked.jpeg",
    ],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "dot-series-3",
    name: "Dot Series 3",
    year: "2021",
    medium: "Acrylic, aerosol on wood panels",
    image:
      "/images/portfolio/paintings/paintings%20feature%20section/dot%20series/ds_3/ds_3_detail.jpeg",
    galleryImages: [
      "/images/portfolio/paintings/paintings%20feature%20section/dot%20series/ds_3/ds_3_front.jpeg",
      "/images/portfolio/paintings/paintings%20feature%20section/dot%20series/ds_3/ds_3_detail.jpeg",
      "/images/portfolio/paintings/paintings%20feature%20section/dot%20series/ds_3/ds_3_side.jpeg",
      "/images/portfolio/paintings/paintings%20feature%20section/dot%20series/ds_3/ds_3_glowDark.jpeg",
    ],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "dot-series-2",
    name: "Dot Series 2",
    year: "2021",
    medium: "Acrylic on canvas",
    image:
      "/images/portfolio/paintings/paintings%20feature%20section/dot%20series/ds_2/ds_2_detail.jpeg",
    galleryImages: [
      "/images/portfolio/paintings/paintings%20feature%20section/dot%20series/ds_2/ds_2_detail.jpeg",
      "/images/portfolio/paintings/paintings%20feature%20section/dot%20series/ds_2/ds_2_front.jpeg",
    ],
    soldOut: true,
    detailPage: true,
  },
  {
    id: "dot-series-1",
    name: "Dot Series 1",
    year: "2021",
    medium: "Acrylic on canvas",
    image: "/images/Store/personal%20work/Dot%20Series%201/ds_1_detail.jpeg",
    galleryImages: [
      "/images/Store/personal%20work/Dot%20Series%201/ds_1_front.jpeg",
      "/images/Store/personal%20work/Dot%20Series%201/ds_1_detail.jpeg",
    ],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "landscape-series-5",
    name: "Landscape Series 5",
    year: "2007",
    medium: "Latex, acrylic, aerosol, matte finish on canvas",
    image:
      "/images/portfolio/paintings/paintings%20feature%20section/landscapes/ls_5/Landscape_5_detail.jpeg",
    galleryImages: [
      "/images/portfolio/paintings/paintings%20feature%20section/landscapes/ls_5/Landscape_5.jpeg",
      "/images/portfolio/paintings/paintings%20feature%20section/landscapes/ls_5/Landscape_5_detail.jpeg",
    ],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "landscape-series-4",
    name: "Landscape Series 4",
    year: "2006",
    medium: "Latex, acrylic, aerosol, matte finish on canvas",
    image:
      "/images/portfolio/paintings/paintings%20feature%20section/landscapes/ls_4/landscape_4.jpeg",
    galleryImages: [
      "/images/portfolio/paintings/paintings%20feature%20section/landscapes/ls_4/landscape_4.jpeg",
    ],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "awr-5",
    name: "Art Within Reach 5",
    year: "2017",
    medium: "Acrylic on canvas",
    image:
      "/images/Store/personal%20work/Art%20Within%20Reach%201/awr_1_front.jpeg",
    galleryImages: [
      "/images/Store/personal%20work/Art%20Within%20Reach%201/awr_1_front.jpeg",
      "/images/Store/personal%20work/Art%20Within%20Reach%201/awr_1_side.jpeg",
    ],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "awr-4",
    name: "Art Within Reach 4",
    year: "2017",
    medium: "Acrylic on canvas",
    image:
      "/images/Store/personal%20work/Art%20Within%20Reach%203/awr_3_front.jpeg",
    galleryImages: [
      "/images/Store/personal%20work/Art%20Within%20Reach%203/awr_3_front.jpeg",
      "/images/Store/personal%20work/Art%20Within%20Reach%203/awr_3_side.jpeg",
    ],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "awr-3",
    name: "Art Within Reach 3",
    year: "2017",
    medium: "Acrylic on canvas",
    image:
      "/images/letteringCalligraphy/Artwork%20Within%20Reach/IMG_1399.jpeg",
    galleryImages: [
      "/images/letteringCalligraphy/Artwork%20Within%20Reach/IMG_1399.jpeg",
      "/images/letteringCalligraphy/Artwork%20Within%20Reach/IMG_1400.jpeg",
    ],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "awr-2",
    name: "Art Within Reach 2",
    year: "2017",
    medium: "Acrylic on canvas",
    image:
      "/images/letteringCalligraphy/Artwork%20Within%20Reach/IMG_1397.jpeg",
    galleryImages: [
      "/images/letteringCalligraphy/Artwork%20Within%20Reach/IMG_1397.jpeg",
      "/images/letteringCalligraphy/Artwork%20Within%20Reach/IMG_1398.jpeg",
    ],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "awr-1",
    name: "Art Within Reach 1",
    year: "2017",
    medium: "Acrylic on canvas",
    image:
      "/images/Store/personal%20work/Art%20Within%20Reach%202/awr_2_front.jpeg",
    galleryImages: [
      "/images/Store/personal%20work/Art%20Within%20Reach%202/awr_2_front.jpeg",
      "/images/Store/personal%20work/Art%20Within%20Reach%202/awr_2_side.jpeg",
    ],
    inquiryOnly: true,
    detailPage: true,
  },
];

const _CD_BASE = "/images/portfolio/collaboration/ordinary%20pals/dudeDetails/";

export const cooperIllustrationProducts = [
  {
    id: "cooper-diers-illustration-1",
    name: "Cooper Diers: Ordinary Pals — Illustration 1",
    year: "2018",
    medium: "Digital illustration",
    image: _CD_BASE + "21a.jpeg",
    galleryImages: [_CD_BASE + "21a.jpeg", _CD_BASE + "21b.jpeg"],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "cooper-diers-illustration-2",
    name: "Cooper Diers: Ordinary Pals — Illustration 2",
    year: "2018",
    medium: "Digital illustration",
    image: _CD_BASE + "19a.jpeg",
    galleryImages: [_CD_BASE + "19a.jpeg", _CD_BASE + "19b.jpeg"],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "cooper-diers-illustration-3",
    name: "Cooper Diers: Ordinary Pals — Illustration 3",
    year: "2018",
    medium: "Digital illustration",
    image: _CD_BASE + "9a.jpeg",
    galleryImages: [_CD_BASE + "9a.jpeg", _CD_BASE + "9b.jpeg"],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "cooper-diers-illustration-4",
    name: "Cooper Diers: Ordinary Pals — Illustration 4",
    year: "2018",
    medium: "Digital illustration",
    image: _CD_BASE + "10a.jpeg",
    galleryImages: [_CD_BASE + "10a.jpeg", _CD_BASE + "10b.jpeg"],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "cooper-diers-illustration-5",
    name: "Cooper Diers: Ordinary Pals — Illustration 5",
    year: "2018",
    medium: "Digital illustration",
    image: _CD_BASE + "2a.jpeg",
    galleryImages: [_CD_BASE + "2a.jpeg", _CD_BASE + "2b.jpeg"],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "cooper-diers-illustration-6",
    name: "Cooper Diers: Ordinary Pals — Illustration 6",
    year: "2018",
    medium: "Digital illustration",
    image: _CD_BASE + "3a.jpeg",
    galleryImages: [_CD_BASE + "3a.jpeg", _CD_BASE + "3b.jpeg"],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "cooper-diers-illustration-7",
    name: "Cooper Diers: Ordinary Pals — Illustration 7",
    year: "2018",
    medium: "Digital illustration",
    image: _CD_BASE + "4a.jpeg",
    galleryImages: [_CD_BASE + "4a.jpeg", _CD_BASE + "4b.jpeg"],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "cooper-diers-illustration-8",
    name: "Cooper Diers: Ordinary Pals — Illustration 8",
    year: "2018",
    medium: "Digital illustration",
    image: _CD_BASE + "5a.jpeg",
    galleryImages: [_CD_BASE + "5a.jpeg", _CD_BASE + "5b.jpeg"],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "cooper-diers-illustration-9",
    name: "Cooper Diers: Ordinary Pals — Illustration 9",
    year: "2018",
    medium: "Digital illustration",
    image: _CD_BASE + "6a.jpeg",
    galleryImages: [_CD_BASE + "6a.jpeg", _CD_BASE + "6b.jpeg"],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "cooper-diers-illustration-10",
    name: "Cooper Diers: Ordinary Pals — Illustration 10",
    year: "2018",
    medium: "Digital illustration",
    image: _CD_BASE + "7a.jpeg",
    galleryImages: [_CD_BASE + "7a.jpeg", _CD_BASE + "7b.jpeg"],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "cooper-diers-illustration-11",
    name: "Cooper Diers: Ordinary Pals — Illustration 11",
    year: "2018",
    medium: "Digital illustration",
    image: _CD_BASE + "8a.jpeg",
    galleryImages: [_CD_BASE + "8a.jpeg", _CD_BASE + "8b.jpeg"],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "cooper-diers-illustration-12",
    name: "Cooper Diers: Ordinary Pals — Illustration 12",
    year: "2018",
    medium: "Digital illustration",
    image: _CD_BASE + "11a.jpeg",
    galleryImages: [_CD_BASE + "11a.jpeg", _CD_BASE + "11b.jpeg"],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "cooper-diers-illustration-13",
    name: "Cooper Diers: Ordinary Pals — Illustration 13",
    year: "2018",
    medium: "Digital illustration",
    image: _CD_BASE + "1a.jpeg",
    galleryImages: [_CD_BASE + "1a.jpeg", _CD_BASE + "1b.jpeg"],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "cooper-diers-illustration-14",
    name: "Cooper Diers: Ordinary Pals — Illustration 14",
    year: "2018",
    medium: "Digital illustration",
    image: _CD_BASE + "22a.jpeg",
    galleryImages: [_CD_BASE + "22a.jpeg", _CD_BASE + "22b.jpeg"],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "cooper-diers-illustration-15",
    name: "Cooper Diers: Ordinary Pals — Illustration 15",
    year: "2018",
    medium: "Digital illustration",
    image: _CD_BASE + "23a.jpeg",
    galleryImages: [_CD_BASE + "23a.jpeg", _CD_BASE + "23b.jpeg"],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "cooper-diers-illustration-16",
    name: "Cooper Diers: Ordinary Pals — Illustration 16",
    year: "2018",
    medium: "Digital illustration (unframed)",
    image: _CD_BASE + "13.jpg",
    galleryImages: [_CD_BASE + "13.jpg"],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "cooper-diers-illustration-17",
    name: "Cooper Diers: Ordinary Pals — Illustration 17",
    year: "2018",
    medium: "Digital illustration (unframed)",
    image: _CD_BASE + "14.jpg",
    galleryImages: [_CD_BASE + "14.jpg"],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "cooper-diers-illustration-18",
    name: "Cooper Diers: Ordinary Pals — Illustration 18",
    year: "2018",
    medium: "Digital illustration (unframed)",
    image: _CD_BASE + "15.jpg",
    galleryImages: [_CD_BASE + "15.jpg"],
    inquiryOnly: true,
    detailPage: true,
  },
  {
    id: "cooper-diers-illustration-19",
    name: "Cooper Diers: Ordinary Pals — Illustration 19",
    year: "2018",
    medium: "Digital illustration (unframed)",
    image: _CD_BASE + "24.jpg",
    galleryImages: [_CD_BASE + "24.jpg"],
    inquiryOnly: true,
    detailPage: true,
  },
];

export const otherDetailProducts = [
  {
    id: "sure-print",
    name: "80AD Gallery: Limited Edition Sure! Print",
    year: "2018",
    medium: "Limited edition print",
    image: "/images/Store/other/OP_80AD_surePrint/_SURE!.jpeg",
    galleryImages: ["/images/Store/other/OP_80AD_surePrint/_SURE!.jpeg"],
    soldOut: true,
    detailPage: true,
  },
  {
    id: "lurker-sticker",
    name: "Lurker",
    medium: "Vinyl sticker",
    image: "/images/Store/stickers/sticker_link.png",
    galleryImages: ["/images/Store/stickers/sticker_link.png"],
    comingSoon: true,
    detailPage: true,
  },
  {
    id: "help-the-helper-sticker",
    name: "Help the Helper",
    medium: "Vinyl sticker",
    image: "/images/portfolio/mspaint/IMG_5366.JPG",
    galleryImages: ["/images/portfolio/mspaint/IMG_5366.JPG"],
    comingSoon: true,
    detailPage: true,
  },
  {
    id: "party-mode-sticker",
    name: "Party Mode",
    medium: "Vinyl sticker",
    image: "/images/portfolio/mspaint/pigface.png",
    galleryImages: ["/images/portfolio/mspaint/pigface.png"],
    comingSoon: true,
    detailPage: true,
  },
  {
    id: "rookie-mistake-sticker",
    name: "Rookie Mistake",
    medium: "Vinyl sticker",
    image: "/images/portfolio/mspaint/butcher.bmp",
    galleryImages: ["/images/portfolio/mspaint/butcher.bmp"],
    comingSoon: true,
    detailPage: true,
  },
  {
    id: "business-casual-sticker",
    name: "Business Casual",
    medium: "Vinyl sticker",
    image: "/images/portfolio/mspaint/chomper.png",
    galleryImages: ["/images/portfolio/mspaint/chomper.png"],
    comingSoon: true,
    detailPage: true,
  },
  {
    id: "asl-sticker",
    name: "A/S/L",
    medium: "Vinyl sticker",
    image: "/images/portfolio/mspaint/IMG_0071.jpeg",
    galleryImages: ["/images/portfolio/mspaint/IMG_0071.jpeg"],
    comingSoon: true,
    detailPage: true,
  },
];
